import React, { useRef, useState, useContext } from "react";
import EstoqueEmbalagensGrid from "./grid";

import { IconButton, Tooltip } from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import SaveIcon from "@mui/icons-material/Save";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import NovoEstoqueEmbalagensFragment from "./novo";
import EstoqueBRF from "../../components/classes/EstoqueBRF";
import Parceiro from "../../components/classes/Parceiro";
import { UserContext } from "../../App";

export default function EstoqueEmbalagensDetalhes(
  props: EstoqueParceiroBRFPropsTypes
) {
  const user: any = useContext(UserContext);
  const [pageState, setPageState] = useState<number>(0);
  const [selectedEstoqueBRF, setSelectedEstoqueBRF] = useState<EstoqueBRF>();

  return (
    <>
      {/*<div className="containerToolbar">
         {pageState == 0 ? (
          <Tooltip title="Novo Registro">
            <span>
              <IconButton onClick={handleNewEstoqueBRF} disabled={user.isSuporte}>
                <InsertDriveFileIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : (
          <Tooltip title="Voltar">
            <IconButton onClick={handleBack}>
              <AssignmentReturnIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
      */}
      {pageState == 1 ? (
        <NovoEstoqueEmbalagensFragment
          onSubmit={handleBack}
          estoqueBRF={selectedEstoqueBRF}
          key={selectedEstoqueBRF?.id}
        />
      ) : null}

      <EstoqueEmbalagensGrid
        parceiro={props.parceiro}
        handleUpdateEstoqueBRF={handleUpdateEstoqueBRF}
        setSelectedEstoqueBRFupdater={setSelectedEstoqueBRF}
        key={Date.now()}
      />
    </>
  );

  function handleNewEstoqueBRF() {
    return setPageState(1);
  }

  function handleUpdateEstoqueBRF() {
    setPageState(0);
    setPageState(1);
  }

  function handleBack() {
    setSelectedEstoqueBRF(undefined);
    return setPageState(0);
  }
}

interface EstoqueParceiroBRFPropsTypes {
  parceiro: Parceiro;
}
